import type { FaireProductEntity } from "../../entity_types/product";

export const p_8bv2jcqqvg: FaireProductEntity = {
  token: "p_8bv2jcqqvg",
  type: "product",
  name: "Bath Bombs",
  brandToken: "b_4wf9xqwxhl",
  brandName: "From Scratch Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/59538fc15af3483c5f8d5b55627bddfb65fafe0450b2d6fd609e40bfd92cb2e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df55f92cc802ec6bb096f862468e45a03ac25c346b3f0d287aa58cbafe3ea545.jpeg",
    "https://cdn.faire.com/fastly/79824e8635f715b90259a3fe0823937ae6bf8d8cc2029b0bbaff0a92eda988ce.jpeg",
    "https://cdn.faire.com/fastly/d5396d295f8c24003193336af360764a50e2c014252adf9441008afd9f6d4537.jpeg",
    "https://cdn.faire.com/fastly/69626c08d9eebe4037cc2f528b086ede3ca2ce1f3e696b2c9b48a84d48d92316.jpeg",
    "https://cdn.faire.com/fastly/ae5c020d8fa87a9a44bab5cb933b5ca0647c1454c51e4b2e8768d756093862c4.jpeg",
    "https://cdn.faire.com/fastly/808d1a102ac2a75dbe06d07a99859e2e4ceb4626606251e2a3154ef727b3d4bc.jpeg",
    "https://cdn.faire.com/fastly/7e0dfb5ca2ab02af480edb6efb81aeef90daa51341fc5fb271f8a38a33495456.jpeg",
    "https://cdn.faire.com/fastly/3e6c1b660f76af109630a282cd3c000b802f03f11d746590f407fa5508248d96.jpeg",
  ],
  priceDollars: 4.8,
  description:
    "12 packaged BATH BOMBS.\n\nIngredients:\nbaking soda\nepsom salt\ncitric acid\ncornstarch\nwater\ncoconut oil\nessential oils\ndried botanicals\n\nVarieties:\nsweet peppermint (made with peppermint essential oil and dried rose petals)- to help awaken or help with congestion\nlemon drop (made with lemon essential oil and dried marigold petals)- to brighten your mood\nlavender (made with lavender essential oil and dried lavender)- to soothe and relax\n\nInstructions:\nDrop bath bomb into tub.  Let fizz.  Soak yourself in bath for 20-40 minutes.  Enjoy!!!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:45.551Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
